import { faAngleRight as fasAngleRight } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import type { ReactNode } from "react";

interface MenuItemProps {
	href: string;
	title: string;
	productCount?: number;
	prepend?: ReactNode;
	append?: ReactNode;
	hasSubItems?: boolean;

	onClick?: () => void;
	onMouseOver?: () => void;
	onFocus?: () => void;
	onMouseMove?: () => void;
	onMouseLeave?: () => void;
}

export const MenuItem = ({
	href,
	prepend,
	append,
	hasSubItems,
	productCount,
	title,
	onClick,
	onMouseOver,
	onFocus,
	onMouseMove,
	onMouseLeave,
}: MenuItemProps) => (
	<div className={classNames("main-menu-item", hasSubItems && "main-menu-item-category")}>
		{prepend && <div className="main-menu-item-prepend">{prepend}</div>}
		<div className="main-menu-item-content">
			<a
				className="main-menu-item-title stretched-link"
				href={href ?? "#"}
				role="menuitem"
				onClick={onClick}
				onMouseOver={onMouseOver}
				onFocus={onFocus}
				onMouseMove={onMouseMove}
				onMouseLeave={onMouseLeave}
			>
				{title}
			</a>
			{!!productCount && <span className="main-menu-item-subtitle">Összesen {productCount} termék</span>}
		</div>
		{append && <div className="main-menu-item-append">{append}</div>}
		{hasSubItems && (
			<div className="ml-auto pl-5 text-muted">
				<FontAwesomeIcon icon={fasAngleRight} />
			</div>
		)}
	</div>
);
